import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { Toaster } from "sonner"
import { AuthProvider } from "./auth/auth-context"
import { App } from "./App"
import "./globals.css"

// Support both tenant mode (#cogo-app) and dev mode (#root)
const container = document.getElementById("cogo-app") || document.getElementById("root")!

createRoot(container).render(
  <StrictMode>
    <AuthProvider>
      <App />
      <Toaster position="top-right" />
    </AuthProvider>
  </StrictMode>,
)
